import { Icon } from "@minted/minted-components";
import PropTypes from "prop-types";
import React from "react";

const OFFSET_PX = 15;

const wrapperStyle = {
  position: "absolute",
  right: `${OFFSET_PX}px`,
  top: `${OFFSET_PX}px`,
  zIndex: 999,
};

const editButtonStyle = {
  alignItems: "center",
  backgroundColor: "#ffffff",
  borderRadius: "50%",
  boxShadow: "0 0 3px rgba(0,0,0,.5)",
  color: "#333333",
  cursor: "pointer",
  display: "flex",
  fontSize: "25px",
  height: "50px",
  justifyContent: "center",
  lineHeight: 1,
  textAlign: "center",
  width: "50px",
};

/**
 * Top-right pencil for a position:relative media frame (e.g. Marquee).
 * Travels with the frame under CSS transforms — unlike EditableHeader's
 * fixed absolute overlays.
 */
const FrameEditPencil = ({ onEdit }) => (
  <div css={wrapperStyle}>
    <div css={editButtonStyle} onClick={onEdit}>
      <Icon type={Icon.types.editSquare} />
    </div>
  </div>
);

FrameEditPencil.propTypes = {
  onEdit: PropTypes.func.isRequired,
};

export default FrameEditPencil;
